import { useQuery } from '@tanstack/react-query';
import { IRpCountResponse } from '@legacy/apis/types/resourcePlannerAPI';
import { getFetch } from '@legacy/utils/fetcher';
import { REFETCH_INTERVAL, RP_PLAN_COUNT_KEY } from '../constants';

const RP_PLAN_COUNT_URL_PATH = '/api/v2/resource-planner/rp-plan-count';

const resourcePlannerFetch = (): Promise<IRpCountResponse> =>
  getFetch({ path: RP_PLAN_COUNT_URL_PATH, key: RP_PLAN_COUNT_KEY });

export const useGetRpPlanCount = (refetch: boolean) => {
  const { data, ...restProps } = useQuery({
    queryFn: resourcePlannerFetch,
    queryKey: [RP_PLAN_COUNT_KEY],
    refetchInterval: refetch ? REFETCH_INTERVAL : undefined,
  });

  return {
    count: data?.model?.properties.count ?? 0,
    ...restProps,
  };
};
